export default __webpack_public_path__ + "static/media/kalimpong1.c76d7f55.jpg";